import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const beeHours: typeof valueTypeRenderers.beeHours = {
  label: () => translate.phrases.banyanApp('Bee Hours'),
  block: () => {
    const baseLabel = unitConverter.beeHours().title()
    const labelCumulative = twoItemLabel([baseLabel, translate.phrases.banyanApp('Cumulative')])

    return (value) => {
      return [
        {
          id: 'current',
          value: unitConverter.beeHours(value === null ? null : value.current).valueAsString(),
          label: baseLabel,
        },
        {
          id: 'cumulative',
          value: unitConverter.beeHours(value === null ? null : value.cumulative).valueAsString(),
          label: labelCumulative,
        },
      ]
    }
  },
}
